import AppIcon from "@/components/AppIcon";
import PlayIcon from "@/components/icons/PlayIcon.vue";
import PauseIcon from "@/components/icons/PauseIcon.vue";
import Alert from "@/components/icons/Alert.vue";
export default {
  name: "PpcCampaignGroupInfo",
  components: {
    AppIcon,
    PlayIcon,
    PauseIcon,
    Alert
  },
  props: {
    item: {
      type: Object
    },
    type: {
      type: String
    },
    blockIconColor: {
      type: String
    },
    ai_status: {
      type: String
    },
    state: {
      type: Boolean,
      String
    }
  },
  methods: {
    getAIStatusIconColor() {
      const colorMap = {
        inactive: "#484c51",
        paused: "#4c4848",
        activated: "#595959"
      };
      return colorMap[this.ai_status];
    },
    getStateIcon() {
      const componentMap = {
        true: "PlayIcon",
        false: "PauseIcon",
        "inconsistent": "Alert"
      };
      return componentMap[this.state];
    },
    getStateBackgroundColor() {
      const colorMap = {
        true: "#DEFBE6",
        false: "#f7de88",
        "inconsistent": "#FFE68F"
      };
      return colorMap[this.state];
    }
  }
};